import { TranslateService } from '@ngx-translate/core';
import { Chat } from '../../bayadic-shared-models/chat/Chat';
import { Injectable } from '@angular/core';
import {Friend} from '../../bayadic-shared-models/classes/user/friend/Friend';
import {StorageManagerProvider} from '../storage-manager/storage-manager';
import {UserManagerProvider} from '../user-manager/user-manager';
import {AjaxBridgeProvider} from '../ajax-bridge/ajax-bridge';
import {SocketManagerProvider} from '../../providers/socket-manager/socket-manager';
import {FriendsOnlineSupplier} from './components/friends-online-supplier/FriendsOnlineSupplier';
import * as Enums from '../../bayadic-shared-models/enums/Enums';


import { FriendsDatabaseManagerProvider } from './database/friends-database-manager-provider';
import { FriendsSynchronizer } from './components/synchronizer/FriendsSynchronizer';
import { Events } from '../../providers/events/events';


@Injectable()
export class FriendsManagerProvider {
  public  friends: Array<Friend>;
  public  backUpFriends: Array<Friend>;
  public friendsStorage: string;
  public storageFriendNotificationNumber = 'friendsNotNum';
  public newFriendsNumber: number ;
  public notficationsNumber: number;
  public synchronizer: FriendsSynchronizer;
 public onlineSupplier: FriendsOnlineSupplier;
 public chat: Chat;
 public x: any;
  constructor(
      public storageManager: StorageManagerProvider,
      public userManager: UserManagerProvider,
      public socketManager: SocketManagerProvider,
      public friendsDatabaseManager: FriendsDatabaseManagerProvider,
      public events: Events,
      public ajaxBridge: AjaxBridgeProvider,
      public translateService: TranslateService ) {
        this.friends = [];
        this.backUpFriends = [];
        this.init();



  }
  async init() {
        await this.userManager.isLoggedIn()

        this.friendsStorage = this.userManager.user.userID + 'friends';
        this.storageFriendNotificationNumber = this.userManager.user.userID + 'friends';

        this.newFriendsNumber = 0;
        this.synchronizer = new FriendsSynchronizer(this);
        await this.getLoadFriends()
        this.synchronizer.sync();
        this.registerEvents();

  }
  registerEvents() {
      this.events.subscribe(Enums.EVENTS.UpdateFriends, (data, time) => {
            this.updateFriend(data);
      });

  }
  updateFriend(friendId) {
    let friend = new Friend({friendID: friendId});
    for (let addedFriend of this.friends) {
        if (addedFriend.userID === friend.userID ) {
           return false;
        }
    }

    this.addToDatabase(friend);
    this.friends.push(friend);
    this.newFriendsNumber++;
    this.save();
  }
    addToDatabase(friend: Friend): boolean {
      
        this.friendsDatabaseManager.add(friend);
        return true;
    }
  addViaAjaxBridge(email) {
      this.socketManager.asyncQuery('addFriend', {email}).then(friendUserObject => {
          if (friendUserObject['found'] === undefined) {
            const friend = new Friend(friendUserObject);
            this.friends.push(friend);
            this.save();
          } else {
          }
      });

  }
 async handleMessage(res) {

        let result = JSON.parse(res);
        if (result.msg) {
            let friendObject = JSON.parse(result.msg);
            if (friendObject.userID ) {
                let friend = new Friend(friendObject);
                if (this.userManager.user.email === friend.email) {
                    return false;
                }
                let alreadyAdded = false;
                for (let addedFriend of this.friends) {
                    if (addedFriend.email === friend.email ) {
                       alreadyAdded = true;
                    }
                }
                if (alreadyAdded) {
                    return true;
                }
                this.friends.push(friend);
                this.friendsDatabaseManager.add(friend);

                this.save();
            }
        } else {
        }
        let title: string;
        this.translateService.get('TITLE.invalidUser').subscribe(
          value => {
            title = value;
          }
        );
        let message: string;
        this.translateService.get('CONTENT.AddFriend').subscribe(
        value => {
          message = value;
        }
      );
   

  }
  add(email: string) {
      this.socketManager.asyncQuery('addFriend', {email});
  }
   searchBackUp() {
      this.backUpFriends = [];
      for (let friend of this.friends) {
          this.backUpFriends.push(friend);
      }
  }
  search(needle: string) {
      this.friends = this.backUpFriends.filter(friend => {
          if (friend.email.includes(needle) || friend.name.includes(needle)) {
            return friend;
          }
      });
  }
  endSearch() {
      this.friends = this.backUpFriends;
  }
  getSimpleModelOfFriends() {
      let simpleModelOfFriends: Array<Friend> = [] ;
      for (let friend of this.friends) {
          simpleModelOfFriends.push(friend.getSimpleModelOfFriend());
      }
      return simpleModelOfFriends;
  }
  save() {
   
        this.storageManager.set(this.friendsStorage, this.getSimpleModelOfFriends());
        this.saveNotificationNumber();
  }
  getLoadFriends() {
      return new Promise((resolve, reject) => {

            this.storageManager.get(this.friendsStorage).then(friends => {
                if (friends) {
                    this.friends = [];
                    for (let friend of friends) {
                        this.friends.push(new Friend(friend));
                    }
                }
                resolve(true);
            });
        });
    }
   initFriends() {
      for (let friend of this.friends) {
          this;
      }
  }
  deleteItem(friend: Friend) {
    this.deleteFriendLocally(friend.userID);
    this.synchronizer.deleteFriend(friend);
  }
  deleteFriendLocally(friendId: string) {
    let friend = new Friend({friendID: friendId});
    const itemIndex = this.friends.indexOf(friend);
    this.friends.splice(itemIndex, 1);
    this.save();
  }
  saveNotificationNumber() {
      this.storageManager.set(this.storageFriendNotificationNumber, this.notficationsNumber);
  }
  clearFriendsNotification() {
      this.newFriendsNumber = 0;
  }
  getNotificationsNumber() {
//    for (let friend of this.friends) {
//        if(friend.item.chat.unreadMessagesNumber > 0)
//            this.notficationsNumber++;
//    }
//      this.storageManager.get(this.storageFriendNotificationNumber).then(notifcsNumber => {
//          this.notficationsNumber = notifcsNumber['notificsnumber'];
//      });
//    return this.notficationsNumber;
      return this.newFriendsNumber;
  }

}
